import React from 'react';
import { Link } from "react-router-dom";
import { all_routes } from '../../router/all_routes';
import CollapseHeader from '../../../core/common/collapse-header';
import { checkPermission } from "../../../core/permissons/CheckPermissons";
import AddVehicleForm from './AddVehicle/addvehicleform';

const route = all_routes;

const AddVehicle = () => {
  const navItems1 = [
    { label: "View Dashboard", icon: "ti ti-layout-dashboard", link: route.VehicleDashboard, permission: "ADMINISTRATION_ACCESS" },
    { label: "View Vehicles", icon: "ti ti-car", link: route.VehicleView, permission: "VEHICLE_MANAGER_ACCESS" },
    { label: "Add Vehicle", icon: "ti ti-settings-cog", link: route.addvehicle, permission: "ADMINISTRATION_ACCESS" },
    { label: "Add Master Data", icon: "ti ti-car", link: route.AddMasterData, permission: "VEHICLE_MANAGER_ACCESS" },
      ];

  return (
    <div className="page-wrapper">
      <div className="content">
      <div className="row">
        <div className="col-md-12">
                    <div className="page-header">
                        <div className="row align-items-center">
                            <div className="col-8">
                                <h4 className="page-title">Vehicle Management/Vehicles/Add Vehicle</h4>
                            </div>
                            <div className="col-4 text-end">
                                <div className="head-icons">
                                    <CollapseHeader />
                                </div>
                            </div>
                        </div>
                    </div>
        <div className="card">
          <div className="card-body pb-0 pt-2">
          <ul className="nav nav-tabs nav-tabs-bottom">
            {navItems1.map((item, index) =>
            item.permission && checkPermission(item.permission) ? (
              <li className="nav-item me-3" key={index}>
              <Link
                to={item.link}
                className={`nav-link px-0 ${index === 2 ? "active" : ""}`}
              >
                <i className={item.icon}></i> {item.label}
              </Link>
              </li>
            ) : null
            )}
          </ul>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-12 col-lg-12">
          <AddVehicleForm />
          </div>
        </div>
        </div>
      </div>
      </div>
    </div>
  );
};

export default AddVehicle;